import {Directive, forwardRef} from '@angular/core';
import {UntypedFormControl, NG_VALIDATORS, Validator} from '@angular/forms';

function validateZipCode() {
  return (c: UntypedFormControl) => {
    const zipCodeRegex = new RegExp(/^[0-9]{5}$/i);

    if (c.value === undefined || c.value === null || c.value?.length === 0){
      return null;
    }
    
    return zipCodeRegex.test(c.value) ? null : {
      zip: {
        valid: false
      }
    };
  };
}

@Directive({
  selector: '[appZipCodeValidator]',
  providers: [
    {provide: NG_VALIDATORS, useExisting: forwardRef(() => ZipCodeValidatorDirective), multi: true}
  ]
})
export class ZipCodeValidatorDirective implements Validator {

  validator: Function;

  constructor() {
    this.validator = validateZipCode();
  }

  validate(c: UntypedFormControl) {
    return this.validator(c);
  }

}
